import { Component, OnInit } from '@angular/core';
import * as feather from 'feather-icons';

declare let Gumshoe: any;

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.sass']
})
export class TopbarComponent implements OnInit {

  private scrollSpy: typeof Gumshoe;

  constructor() { }

  ngOnInit(): void {
    /*********************/
    /*  Clickable manu   */
    /*********************/
    let nav = document.getElementById("navigation");
    if(nav != null) {
      var elements = nav.getElementsByTagName("a");
      for (var i = 0, len = elements.length; i < len; i++) {
          elements[i].onclick = function (elem) {
              if ((<HTMLAnchorElement>elem.target)?.getAttribute("href") === "javascript:void(0)") {
                  var submenu = (<HTMLAnchorElement>elem.target)?.nextElementSibling?.nextElementSibling;
                  submenu?.classList.toggle('open');
              }
          }
      }
    };

    /*********************/
    /*   Feather Icons   */
    /*********************/
    feather.replace();

    /*********************/
    /*     Small Menu    */
    /*********************/
    try {
        this.scrollSpy = new Gumshoe('#navmenu-nav a');
    } catch (err) {

    }

    window.addEventListener('scroll', (ev) => {
      ev.preventDefault();
      this.windowScroll();
    });
  }


  /*********************/
  /* Toggle Menu */
  /*********************/
  toggleMenu(): void {
    document.getElementById('isToggle')?.classList.toggle('open');
    let isOpen = document.getElementById('navigation');
    if(isOpen == null) {
      return;
    }

    if (isOpen.style.display === "block") {
        isOpen.style.display = "none";
    } else {
        isOpen.style.display = "block";
    }
  };
  /*********************/
  /*    Menu Active    */
  /*********************/
  getClosest(elem:any, selector:any): any {
    // Element.matches() polyfill
    /*if (!Element.prototype.matches) {
        Element.prototype.matches =
            (<any>Element.prototype).matchesSelector ||
            (<any>Element.prototype).mozMatchesSelector ||
            (<any>Element.prototype).msMatchesSelector ||
            (<any>Element.prototype).oMatchesSelector ||
            (<any>Element.prototype).webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (elem.matches(selector)) return elem;
    }
    return null;*/
    return null;

  };

  activateMenu(): void {
    var menuItems = document.getElementsByClassName("sub-menu-item");
    if (menuItems) {

        var matchingMenuItem = null;
        for (var idx = 0; idx < menuItems.length; idx++) {
            if ((<HTMLAnchorElement>menuItems[idx]).href === window.location.href) {
                matchingMenuItem = menuItems[idx];
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add('active');


            var immediateParent = this.getClosest(matchingMenuItem, 'li');

            if (immediateParent) {
                immediateParent.classList.add('active');
            }

            var parent = this.getClosest(immediateParent, '.child-menu-item');
            if(parent){
                parent.classList.add('active');
            }

            var parent = this.getClosest(parent || immediateParent , '.parent-menu-item');

            if (parent) {
                parent.classList.add('active');

                var parentMenuitem = parent.querySelector('.menu-item');
                if (parentMenuitem) {
                    parentMenuitem.classList.add('active');
                }

                var parentOfParent = this.getClosest(parent, '.parent-parent-menu-item');
                if (parentOfParent) {
                    parentOfParent.classList.add('active');
                }
            } else {
                var parentOfParent = this.getClosest(matchingMenuItem, '.parent-parent-menu-item');
                if (parentOfParent) {
                    parentOfParent.classList.add('active');
                }
            }
        }
    }
  }

  /*********************/
  /*   Menu Sticky     */
  /*********************/
  windowScroll(): void {
    const navbar = document.getElementById("topnav");
    if (navbar != null) {
        if (
            document.body.scrollTop >= 50 ||
            document.documentElement.scrollTop >= 50
        ) {
            navbar.classList.add("nav-sticky");
        } else {
            navbar.classList.remove("nav-sticky");
        }
    }
  };
}
